<!--<div style="text-align:center; margin: 2rem 0;">
    <img src="assets/images/projetos.jpeg" alt="Agenda" style="width: 100%; max-width: 900px; height: auto; border-radius: 12px; box-shadow: 0 2px 8px rgba(44, 131, 179, 0.08); opacity: 0.8;">
</div>-->

<div class="cadastro-cliente-container">
  <div class="header">
    <h1>Cadastro de Projeto</h1>
  </div>

  <form [formGroup]="cadastroForm" (ngSubmit)="onSubmit()" class="form-cadastro">
    
    <!-- Resumo do Projeto -->
    <div class="section">
      <h2 class="section-title">
        <i class="fas fa-file-alt"></i>
        Resumo do Projeto
      </h2>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="resumoProjeto">Resumo do Projeto *</label>
            <small class="text-muted d-block mb-2">
              <i class="fas fa-info-circle"></i>
              Mínimo 1000 caracteres
            </small>
            <textarea 
              id="resumoProjeto" 
              class="form-control" 
              formControlName="RESUMO_PROJETO"
              rows="6"
              placeholder="Descreva um resumo detalhado do seu projeto, incluindo objetivos, metodologia e resultados esperados"></textarea>
            <div class="error-message" *ngIf="cadastroForm.get('RESUMO_PROJETO')?.invalid && cadastroForm.get('RESUMO_PROJETO')?.touched">
              Resumo do projeto é obrigatório
            </div>
            <div class="char-count" *ngIf="cadastroForm.get('RESUMO_PROJETO')?.value">
              {{ cadastroForm.get('RESUMO_PROJETO')?.value?.length || 0 }} caracteres
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Área de Relação com o PPGIT -->
    <div class="section">
      <h2 class="section-title">
        <i class="fas fa-network-wired"></i>
        Área de Relação com o PPGIT
      </h2>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="areaRelacaoPPGIT">Área de Relação com o PPGIT *</label>
            <div class="areas-selection">
              <div class="area-option" *ngFor="let area of areasPPGIT; let i = index">
                <div class="form-check">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    [id]="'area' + i"
                    [value]="area.value"
                    [checked]="isAreaSelected(area.value)"
                    (change)="toggleArea(area.value, $event)">
                  <label class="form-check-label" [for]="'area' + i">
                    <strong>{{ area.label }}</strong>
                  </label>
                </div>
                <div class="area-description">
                  {{ area.description }}
                </div>
              </div>
            </div>
            <div class="error-message" *ngIf="cadastroForm.get('AREA_RELACAO_PPGIT')?.invalid && cadastroForm.get('AREA_RELACAO_PPGIT')?.touched">
              Selecione pelo menos uma área de relação com o PPGIT
            </div>
            <div class="help-text">
              <small class="text-muted">
                <i class="fas fa-info-circle"></i>
                Selecione uma ou mais áreas de concentração que se relacionam com seu projeto. Você pode selecionar múltiplas opções.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Palavras-Chave do Projeto -->
    <div class="section">
      <h2 class="section-title">
        <i class="fas fa-tags"></i>
        Palavras-Chave do Projeto
      </h2>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="palavrasChave">Palavras-Chave do Projeto *</label>
            <textarea 
              id="palavrasChave" 
              class="form-control" 
              formControlName="PALAVRAS_CHAVE"
              rows="3"
              placeholder="Digite as palavras-chave separadas por vírgula (ex: inteligência artificial, machine learning, processamento de dados)"></textarea>
            <div class="error-message" *ngIf="cadastroForm.get('PALAVRAS_CHAVE')?.invalid && cadastroForm.get('PALAVRAS_CHAVE')?.touched">
              Palavras-chave são obrigatórias
            </div>
            <div class="help-text">
              <small class="text-muted">
                <i class="fas fa-info-circle"></i>
                Separe as palavras-chave por vírgula. Recomendamos entre 3 e 8 palavras-chave.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Botões de Ação -->
    <div class="form-actions">
      <button type="button" class="btn btn-secondary" (click)="limparFormulario()">
        <i class="fas fa-times"></i>
        Limpar
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="!cadastroForm.valid">
        <i class="fas fa-save"></i>
        Salvar Projeto
      </button>
    </div>
  </form>
</div>
  